import { Badge } from "@chakra-ui/react";

const BadgeFormApproveStatus = ({ data }) => {
    let color = "gray"
    let text = ""
    switch (data.approve_result) {
        case "None": color = "gray";
            text = "ยังไม่ได้ตรวจสอบ"
            break;
        case "Accept": color = "green"
            text = "ผ่าน"
            break;
        case "Reject": color = "red"
            text = "ไม่ผ่าน"
            break;
        default: color = "gray"
            text = ""
    }

    return (
        <Badge colorScheme={color}>{text}</Badge>
    )
}

export default BadgeFormApproveStatus